import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '70%',
    border: '1px solid #a18a8a',
    padding: '5px 20px',
    marginBottom: 8,
    borderRadius: 10,
  },
}));
